import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
import Login from '../components/Login.vue';
import DashboardLogin from '../components/DashboardLogin.vue';
import Register from '../components/Register.vue';
// import RestorePassword from '../components/RestorePassword.vue';
import CheckerAccounts from '../views/CheckerAccounts.vue';
import CheckerTokens from '../views/CheckerTokens.vue';
import CheckerCookies from '../views/CheckerCookies.vue';
import Converter from '../views/Converter.vue';
import Dashboard from '../views/Dashboard.vue';
import DashboardChecks from '../views/DashboardChecks.vue';
import DashboardDonors from '../views/DashboardDonors.vue';
import DashboardDonor from '../views/DashboardDonor.vue';
import DashboardImport from '../views/DashboardImport.vue';
import DashboardProxy from '../views/DashboardProxy.vue';
import DashboardSettings from '../views/DashboardSettings.vue';
// import Pay from '../views/Pay.vue';
// import InvoiceStatus from '../views/InvoiceStatus.vue';
// import Referral from '../views/Referral.vue';
// import ConnectTgBot from '../views/ConnectTgBot.vue';

const routes = [
  {
    path: '/reg',
    name: 'Register',
    component: Register,
    meta: {
      title: 'Регистрация'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Авторизация'
    }
  },
  {
    path: '/dashboard/login',
    name: 'DashboardLogin',
    component: DashboardLogin,
    meta: {
      title: 'Авторизация админа'
    }
  },
  // {
  //   path: '/restore',
  //   name: 'RestorePassword',
  //   component: RestorePassword,
  //   meta: {
  //     title: 'Восстановление пароля'
  //   }
  // },
  // {
  //   path: '/pay',
  //   name: 'Pay',
  //   component: Pay,
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  {
    path: '/dashboard/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAdminAuth: true
    }
  },
  {
    path: '/dashboard/checks',
    name: 'DashboardChecks',
    component: DashboardChecks,
    meta: {
      requiresAdminAuth: true
    }
  },
  {
    path: '/dashboard/donors',
    name: 'DashboardDonors',
    component: DashboardDonors,
    meta: {
      requiresAdminAuth: true
    }
  },
  {
    path: '/dashboard/donors/:id',
    name: 'DashboardDonor',
    component: DashboardDonor,
    meta: {
      requiresAdminAuth: true
    }
  },
  {
    path: '/dashboard/import',
    name: 'DashboardImport',
    component: DashboardImport,
    meta: {
      requiresAdminAuth: true
    }
  },
  {
    path: '/dashboard/proxy',
    name: 'DashboardProxy',
    component: DashboardProxy,
    meta: {
      requiresAdminAuth: true
    }
  },
  {
    path: '/dashboard/settings',
    name: 'DashboardSettings',
    component: DashboardSettings,
    meta: {
      requiresAdminAuth: true
    }
  },
  // {
  //   path: '/invoice/check/:id',
  //   name: 'InvoiceStatus',
  //   component: InvoiceStatus,
  //   // meta: {
  //   //   // title: 'Проверка платежа',
  //   //   requiresAuth: true
  //   // }
  // },
  // {
  //   path: '/referral',
  //   name: 'Referral',
  //   component: Referral,
  //   // meta: {
  //   //   requiresAuth: true
  //   // }
  // },
  {
    path: '/',
    name: 'CheckerAccounts',
    component: CheckerAccounts,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/tokens',
    name: 'CheckerTokens',
    component: CheckerTokens,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cookies',
    name: 'CheckerCookies',
    component: CheckerCookies,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/converter',
    name: 'Converter',
    component: Converter
  },
  {
    path: '/converter/:id',
    redirect: to => {
      if (!store.getters.isLoggedIn && Number(to.params.id)) {
        localStorage.checkerPartner = to.params.id;
      }
      return { name: 'Converter' };
    }
  },
  // {
  //   path: '/p/:id',
  //   redirect: to => {
  //     if (!store.getters.isLoggedIn) {
  //       localStorage.checkerPartner = to.params.id;
  //     }
  //     return { path: '/' };
  //   }
  // },
  // {
  //   path: '/tgbot/connect/:hash',
  //   name: 'ConnectTgBot',
  //   component: ConnectTgBot,
  //   // meta: {
  //   //   // title: 'Проверка платежа',
  //   //   requiresAuth: true
  //   // }
  // },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  
  if (
    (to.name === 'Login' ||
      to.name === 'Register' ||
      to.name === 'RestorePassword') &&
    store.getters.isLoggedIn
  ) {
    next('/');
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {

      next();
      return;
    }
    
    console.log(to.href);
    
    next({ path: '/login', query: { next: to.path } });
  } else if (to.matched.some(record => record.meta.requiresAdminAuth)) {
    console.log('is admin logged in: ' + store.getters.isAdminLoggedIn)
    if (store.getters.isAdminLoggedIn) {
      console.log('authenticated')
      next();
      return;
    }

    console.log('not authenticated')
    // console.log(to.href);
    
    next({ path: '/dashboard/login', query: { next: to.path } });
  } else {

    next();
  }

});

export default router;
